import { $FixMe } from '@eventbrite/legacy-infra.ts-utils';
import { GenericLazyString } from './genericLazyString';

export const gettext = (key: string, interpolation?: Record<string, $FixMe>) => {
    let text = key;
    if (interpolation) {
        text = key.replace(/%\((\w+)\)s/g, (match, k) => {
            return k in interpolation ? interpolation[k] : match;
        });
    }

    return new GenericLazyString(() => text);
};
